import { createAsyncThunk } from "@reduxjs/toolkit";

export const switchCurrency = createAsyncThunk(
  "dashboard/switchCurrency",
  async (payload) => {
    return payload;
  }
);
